import type {ReactElement} from 'react';
import {useState} from 'react';
import {useEffect} from 'react';
import React from 'react';
import styles from './poster-editor-toolbar.module.scss';
import {isTemplatesPopupHidden} from '@Components/poster-editor/library/poster-editor-library';
import {ADD_ITEM_BAR_ITEM_GAP, ADD_ITEM_BAR_ITEM_HEIGHT} from './poster-editor-toolbar.types';

interface ToolbarProps {
  items: ReactElement<any>[];
  className?: string;
  maxHeight?: number;
}

const ADD_ITEM_BAR_SPSACING = 18;

export function PosterEditorToolbar({className = '', maxHeight, ...props}: ToolbarProps): ReactElement<any> {
  const [height, setHeight] = useState<number>();
  const [updatedItems, setUpdatedItems] = useState<ReactElement<any>[]>();

  useEffect((): void => {
    let numItems = props.items.length;
    if (isTemplatesPopupHidden()) {
      numItems -= 1;
    }
    const spacing = ADD_ITEM_BAR_ITEM_HEIGHT * numItems + (numItems - 1) * ADD_ITEM_BAR_ITEM_GAP + ADD_ITEM_BAR_SPSACING;
    setHeight(spacing);
    setUpdatedItems(updatedItems);
  }, [props.items.length]);

  return (
    <div
      style={{
        height: height,
        maxHeight: maxHeight,
      }}
      className={`${className} ${styles.container} shadow-floating-elevation-2 flex-column-align-center border-s-standard radius-12 spacing-p-2 js-blurred-during-onboarding`}
    >
      {props.items}
    </div>
  );
}
